


<template>
  <Card title="消息中心">
    <div style="margin-bottom: 2vh;">
      <a-row>
        <a-col :span="20">
          <a-form-model layout="inline" @keyup.enter.native="query">
            <a-form-model-item>
              <InputField labelWidth="0" type="text" id="location" v-model="form.title" placeholder="标题"/>
            </a-form-model-item>

            <a-form-model-item>
              <RadioField name="type" :options="isReadOptions" v-model="form.isRead"/>
            </a-form-model-item>

            <a-form-model-item>
              <a-space>
                  <ButtonField text="查询" @click="query" secondary />
                  <ButtonField text="重置" primary @click="reset"/>
              </a-space>
            </a-form-model-item>
          </a-form-model>
        </a-col>

        <a-col :span="4">
          <div class="right">
              <ButtonField text="全部已读" @click="readAll"  :disabled="list.length === 0" secondary />
          </div>
        </a-col>
      </a-row>
    </div>
      <Tablelist
              :showCheckbox="false"
              :list="list"
              :columns="tableColumns"
      />
  </Card>
</template>
  
<script>
import request from "@/api/request";

function fetchList(params) {
  return request({
    url: "/basic-service/message/list",
    params,
  });
}

function readAllRequest() {
  return request({
    url: "/basic-service/message/allRead",
    method: "post",
  });
}

export default {
  data() {
    return {
      form: {
        isRead: 0,
      },
      loading: false,
      current: 1,
      pageSize: 10,
      list: [],
      total: 0,
      isReadOptions: [{name: '已读',value: 1,},{name: '未读',value: 0,}],
      allReadLoading: false,
      tableColumns: [
          {
              key: 'fromName',
              title: '消息来源',
              field: 'fromName',
              infotype: 'text'
          },
          {
              key: 'title',
              title: '标题',
              field: 'title',
              infotype: 'text',
          },
          {
              key: 'content',
              title: '内容',
              field: 'content',
              infotype: 'text',
          },
          {
              key: 'createAt',
              title: '创建时间',
              field: 'createAt',
              infotype: 'text',
          }
      ],

    };
  },

  mounted() {
    this.getList();
  },

  methods: {
    getList() {
      this.loading = true;
      const { current, pageSize } = this;

      fetchList({
        pageNum: current,
        pageSize: pageSize,
        ...this.form,
      })
        .then((res) => {
          if (Array.isArray(res.list)) {
            this.list = Object.freeze(res.list);
            this.total = res.totalSize || 0;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    onChange(pagination) {
      this.current = pagination.current;
      this.getList();
    },

    query() {
      this.current = 1;
      this.getList();
    },
    reset() {
      this.form = {
        isRead: 0,
      };
      this.current = 1;
      this.getList();
    },

    readAll() {
      const that = this;

      this.$confirm({
        title: `确定全部已读吗？`,
        onOk() {
          that.allReadLoading = true;
          readAllRequest().finally(() => {
            that.allReadLoading = false;
          });
        },
      });
    },
  },
};
</script>
